'use client'
import React, { useEffect } from 'react'
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

function HeroSection() {
   function setDelayAndPlay(video, swiperInstance) {
      const durationInMs = video.duration * 1000

      // Set autoplay delay to match video duration
      swiperInstance.params.autoplay.delay = durationInMs
      swiperInstance.autoplay.start()

      video.play().catch((err) => {
         console.warn('Video play error:', err)
      })
   }

   function playVideoWithDynamicDelay(index, swiperInstance) {
      const allSlides = document.querySelectorAll('.swiper-slide')

      // Pause and reset all videos
      allSlides.forEach((slide) => {
         const video = slide.querySelector('video')
         if (video) {
            video.pause()
            video.currentTime = 0
         }
      })

      // Get the active slide
      const activeSlide = [...allSlides].find(
         (slide) =>
            parseInt(slide.getAttribute('data-swiper-slide-index')) === index
      )

      if (!activeSlide) return

      const activeVideo = activeSlide.querySelector('video')
      if (!activeVideo) return

      // Wait until video metadata is loaded
      if (activeVideo.readyState >= 1) {
         setDelayAndPlay(activeVideo, swiperInstance)
      } else {
         activeVideo.addEventListener(
            'loadedmetadata',
            () => setDelayAndPlay(activeVideo, swiperInstance),
            { once: true }
         )
      }
   }

   useEffect(() => {
      const homeNav = document.querySelector('.home-nav')
      const navItems = document.querySelectorAll('.home-nav .nav-item')

      navItems.forEach((item) => {
         item.addEventListener('mouseenter', () => {
            homeNav.classList.add('hovered')
         })
         item.addEventListener('mouseleave', () => {
            homeNav.classList.remove('hovered')
         })
      })
      return () => {}
   }, [])

   // useEffect(() => {
   //    const handleScroll = () => {
   //       const navbar = document.querySelector('.navbar')
   //       if (window.scrollY > 100) {
   //          navbar.classList.add('scrolled')
   //          navbar.classList.remove('home-nav')
   //       } else {
   //          navbar.classList.remove('scrolled')
   //          navbar.classList.add('home-nav')
   //       }
   //    }

   //    // Attach scroll event listener
   //    window.addEventListener('scroll', handleScroll)

   //    // Cleanup the event listener on component unmount
   //    return () => {
   //       window.removeEventListener('scroll', handleScroll)
   //    }
   // }, [])

   return (
      <section className="home-page-top-section">
         <Swiper
            modules={[Navigation, Pagination, Autoplay, EffectFade]}
            effect="fade"
            spaceBetween={50}
            loop={true}
            pagination={{
               el: '.swiper-pagination',
               clickable: true,
            }}
            autoplay={{
               delay: 15000,
               disableOnInteraction: false,
            }}
            fadeEffect={{ crossFade: true }}
            slidesPerView={1}
            onInit={(swiper) => {
               playVideoWithDynamicDelay(swiper.realIndex, swiper)
            }}
            onSlideChangeTransitionEnd={(swiper) => {
               playVideoWithDynamicDelay(swiper.realIndex, swiper)
            }}
            className="home-banner-swiper"
         >
            <SwiperSlide>
               {' '}
               <video
                  className="slide-video"
                  playsInline
                  muted
                  loop
                  preload="auto"
                  autoPlay
               >
                  <source
                     src="/assets/videos/home/hero-slider-3.mp4"
                     type="video/mp4"
                  />
               </video>{' '}
            </SwiperSlide>
            <SwiperSlide>
               {' '}
               <video
                  className="slide-video"
                  playsInline
                  muted
                  loop
                  preload="auto"
                  autoPlay
               >
                  <source
                     src="/assets/videos/home/hero-slider-2.mp4"
                     type="video/mp4"
                  />
               </video>{' '}
            </SwiperSlide>
            {/* <SwiperSlide>
               {' '}
               <video
                  className="slide-video"
                  playsInline
                  muted
                  loop
                  preload="auto"
                  autoPlay
               >
                  <source
                     src="/assets/videos/home/hero-slider-01.mp4"
                     type="video/mp4"
                  />
               </video>{' '}
            </SwiperSlide> */}
            <div className="swiper-pagination"></div>
         </Swiper>
      </section>
   )
}

export default HeroSection
